module.exports = __webpack_public_path__ + "img/chevron-bottom.5d0b0e38.svg";